export default __webpack_public_path__ + "static/media/replicate.b0ef7b60.png";